import { Button } from "antd";
import { useLongPress } from "./Utils";

export default function ArrowButton({ icon, onShortClick, onLongClick, className, delay = 500 }) {
  // Pass the functions dynamically
  const handlers = useLongPress({ onShortClick, onLongClick, delay });

  return (
    <Button className={className} {...handlers}>
      {icon}
    </Button>
  );
}
